import React from "react";
import { Logo } from "../assets/logo";
import { BookButton } from "../ui/BookButton";
import { useTranslation } from "react-i18next";

export const TransformCard = () => {
  const { t } = useTranslation();
  return (
    <div className="flex justify-center items-center">
      <div className="relative flex w-[90%] md:w-[70%] max-w-[900px] rounded-[13px] p-[1px]">
        <div
          className="absolute inset-0 rounded-[13px] p-[2px] pointer-events-none"
          style={{
            background: "linear-gradient(115deg, #EFE6FF, #6C3BC7)",
            maskImage: "linear-gradient(white, white)",
            WebkitMaskImage: "linear-gradient(white, white)",
          }}
        />
        <div className="relative w-full h-full rounded-[12px] px-[24px] py-[30px] flex flex-col-reverse md:flex-row gap-4 md:gap-0 md:py-[46px] md:px-[40px] justify-between items-center bg-gradient-to-l from-white to-neutral-400">
          <div className="flex flex-col gap-4 text-center align-center md:text-left md:w-[60%]">
            <p className="text-primary-700 font-600 text-[24px] px-[5px]">
              {String(t("transformCard.title"))}
            </p>
            <p className="text-neutral-200 font-400 text-[16px]">
              {String(t("transformCard.subtitle"))}
            </p>
            <div>
              <BookButton />
            </div>
          </div>
          <div className="flex items-center mt-[20px] md:mt-0 md:mr-2 pr-4-res md:w-[60%] justify-center md:justify-end">
            <Logo
              height="72px"
              width="218px"
              className="h-[52px] md:h-[72px]"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
